import React, { Component } from "react";
import { connect } from "react-redux";
import { DIMENSIONS } from "services/layoutManager";
import BloxPage from "sub_components/Layout/BloxPage";
import ComponentWrapper from "sub_components/Layout/ComponentWrapper";
import DonutChart from "sub_components/Common/DonutChart";
import IssueRequest from "blox_components/Support/IssueRequestNew/IssueRequest";
import ServiceRequest from "blox_components/Support/ServiceRequest";
import { ActionButton } from "styled_components/Common/ActionButton";
import { ShippingSVG } from "styled_components/SVG/ShippingSVG";
import { ServiceRequestProvider } from "context/ServiceRequestContext";
import { BloxButton } from "styled_components/Common/BloxButton";
import { JoyRideToolTip } from "styled_components/Common/JoyRideToolTip";
import {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
} from "actions/siteTracking";
import { MENU as SUPPORT_MENU } from "utils/TicketConstants";
import { SITE_PAGES, SITE_MODULES } from "utils/CommonConstants";
import { TICKET_TYPES } from "utils/TicketConstants";
import { RESOLUTIONS } from "services/config";
import { Utils } from "services/utils";
import { setHomeTour } from "actions/tour";
import { updatePermissions } from "actions/permissions";
import { IssueRequestTour } from "styled_components/Tour/IssueRequestTour";
import { getUserPermissions, setUserPermissions } from "services/user";
import { RecentTickets } from "styled_components/Support/RecentTickets";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride-react-19";
import { TicketApi } from "services/ticket";

import { Permissions } from "services/permissions";

const LAYOUT_CONFIG = {
  [RESOLUTIONS.LOW]: {
    issueRequest: { x: 1, y: 24, dim: DIMENSIONS.TWO_BY_TWO },
    tourButton: { x: 1, y: 54, dim: DIMENSIONS.TWO_BY_TWO },
    shippingRequest: { x: 3, y: 24, dim: DIMENSIONS.TWO_BY_TWO },
    remoteHandsRequest: { x: 6, y: 24, dim: DIMENSIONS.FOUR_BY_THREE },
    guestAccessRequest: { x: 9, y: 24, dim: DIMENSIONS.FOUR_BY_THREE },
    ticketDonut: { x: 10, y: 2, dim: DIMENSIONS.TWO_BY_TWO },
    recentTickets: { x: 1, y: 2, dim: DIMENSIONS.TWO_BY_SIX },
  },
  [RESOLUTIONS.MED]: {
    issueRequest: { x: 1, y: 31, dim: DIMENSIONS.TWO_BY_TWO },
    shippingRequest: { x: 3, y: 31, dim: DIMENSIONS.TWO_BY_TWO },
    remoteHandsRequest: { x: 6, y: 31, dim: DIMENSIONS.FOUR_BY_THREE },
    guestAccessRequest: { x: 9, y: 31, dim: DIMENSIONS.FOUR_BY_THREE },
    ticketDonut: { x: 10, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    tourButton: { x: 0, y: 120, dim: DIMENSIONS.TWO_BY_TWO },
    recentTickets: { x: 1, y: 2, dim: DIMENSIONS.TWO_BY_SIX },
  },
  [RESOLUTIONS.HIGH]: {
    issueRequest: { x: 1, y: 50, dim: DIMENSIONS.TWO_BY_TWO },
    shippingRequest: { x: 3, y: 50, dim: DIMENSIONS.TWO_BY_TWO },
    remoteHandsRequest: { x: 6, y: 50, dim: DIMENSIONS.FOUR_BY_THREE },
    guestAccessRequest: { x: 9, y: 50, dim: DIMENSIONS.FOUR_BY_THREE },
    ticketDonut: { x: 10, y: 3, dim: DIMENSIONS.TWO_BY_TWO },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
    recentTickets: { x: 1, y: 2, dim: DIMENSIONS.TWO_BY_SIX },
  },
};

class OverviewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTitleTicketCount: true,
      hasShippingTickets: false,
      runTour: false,
      tourSelected: null,
      stepIndex: 0,
      ticketType: null,
      updateCount: 0,
    };
  }

  componentWillUnmount() {
    Utils.removeHorizontalBar();
  }
  showTitleTicketCount = (show) => {
    const { showTitleTicketCount } = this.state;

    if (showTitleTicketCount !== show) {
      this.setState({ showTitleTicketCount: show });
    }
  };

  getTicketType = (type) => {
    TicketApi.getTicketType(type)
      .then((response) => {
        if (response.status === 200 && response?.data && !response.data.error) {
          this.setState({ ticketType: response?.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentDidMount() {
    const {
      updateModule,
      updatePage,
      addPageToBreadCrumbs,
      site,
      permissions,
      location,
      setHomeTour,
    } = this.props;
    updatePage(SITE_PAGES.SUPPORT[SUPPORT_MENU.OVERVIEW]);
    addPageToBreadCrumbs(
      SITE_PAGES.SUPPORT[SUPPORT_MENU.OVERVIEW],
      SITE_MODULES.SUPPORT
    );
    const tour = location?.state?.tour;
    if (tour) {
      this.setState({ tourSelected: tour });
    }
    const search = location?.search;
    Utils.removeScroll();
    if (search.includes("tour=true")) {
      setHomeTour({ runHomeTour: true, action: "start" });
      this.setState({ runTour: true });
    }

    if (site?.module !== "SUPPORT" || !permissions?.permissions) {
      this.getModulePages();
    }
    updateModule(SITE_MODULES.SUPPORT);
    this.checkForCompanyId();
    Utils.showHorizontalBar();
    this.getTicketType("support");
  }
  componentDidUpdate(prevProps) {
    const { location, setHomeTour } = this.props;
    this.checkForCompanyId();
    const search = location?.search;
    const prevSearch = prevProps?.location?.search;
    const prevLocation = prevProps.location;
    if (search !== prevSearch && search.includes("tour=true")) {
      setHomeTour({ runHomeTour: true, action: "start" });
    }
    if (location !== prevLocation) {
      const tour = location?.state?.tour;
      this.setState({ tourSelected: tour });
    }
  }

  checkForCompanyId = () => {
    const {
      company_info: { customer: { id } = {} },
    } = this.props;
    const { organizationId: existingId, error } = this.state;

    if (id !== existingId && !error) {
      this.checkUsersRole(id);
    }
  };

  checkUsersRole = (id) => {
    const { auth_status } = this.props;
    const { role } = this.state;
    const { memberships = {} } = auth_status;
    const currentMembershipSelected = memberships.filter(
      (membership) => Number(membership.organizationId) === Number(id)
    );
    if (currentMembershipSelected[0].role !== role) {
      this.setState({ role: currentMembershipSelected[0].role });
    }
    return currentMembershipSelected[0].role;
  };

  goTo = (page) => {
    const { navigate } = this.props;
    navigate(`/portal/support/${page}`);
  };

  getModulePages = async () => {
    const {
      updatePermissions,
      auth_status: {
        user: { id: userId },
      },
      company_info: {
        customer: { id: orgId },
      },
    } = this.props;
    //check cache
    const permissions = getUserPermissions("support");

    if (!permissions) {
      const response = await Permissions.getModulePermissions(2, userId, orgId);
      if (response && !response.data.error) {
        setUserPermissions("support", response.data.pages);
        updatePermissions(response.data.pages);
        this.setState({
          loaded: true,
        });
      }
    } else {
      updatePermissions(permissions);
    }
  };

  onSelectTicket = (ticket) => {
    const { addPageToBreadCrumbs, updatePage, navigate } = this.props;
    const url = `/portal/support/ticket_history/support/${ticket.id}`;

    updatePage(SITE_PAGES.SUPPORT[SUPPORT_MENU.TICKET_HISTORY_DETAIL]);
    addPageToBreadCrumbs(`TICKET #${ticket.id}`, SITE_MODULES.SUPPORT, url);

    navigate(url);
  };

  goToTicketHistory = (status) => {
    const { navigate } = this.props;

    navigate("/portal/support/ticket_history", {
      state: { status, type: "Any" },
    });
  };
  setHasShippingTickets = (hasTickets) => {
    this.setState({ hasShippingTickets: hasTickets });
  };

  handleTourCallback = (data) => {
    const { navigate, location } = this.props;
    const { action, index, status, type } = data;
    const serviceRequestModal = document.getElementById("icon-button");
    const issueRequestModal = document.getElementById("cancel-button-swipe");
    const issueRequestButton = document.getElementById("special-id-2");

    if ([ACTIONS.CLOSE].includes(action) || data?.status === "finished") {
      this.setState({ tourSelected: null, stepIndex: 0 });
      navigate(location?.pathname);

      if (issueRequestModal) {
        issueRequestModal.click();
        setTimeout(() => issueRequestButton.classList.remove("active"), 1000);
      }
      if (serviceRequestModal) {
        serviceRequestModal.click();
      }
    } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // Update state to advance the tour
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false, so we can restart if we click start again.

      this.setState({ tourSelected: null, stepIndex: 0 });

      navigate(location?.pathname);

      if (issueRequestModal) {
        issueRequestModal.click();

        setTimeout(() => issueRequestButton.classList.remove("active"), 1000);
      }
    }
  };

  closeTour = (joyride) => {
    const { setHomeTour, navigate } = this.props;
    const action = joyride?.action;
    if (action === "close" || action === "reset" || action === "stop") {
      setHomeTour({ runHomeTour: false, action });
      this.setState({ runTour: false });
      navigate("/portal/support");
    }
  };
  setStepIndex = (index) => {
    this.setState({ stepIndex: index });
  };

  onClick = (id) => {
    const element = document.getElementById(id);
    element.classList.toggle("active");
    document.getElementById(`${id}trans2`).beginElement();
    if (document.getElementById(`${id}trans3`)) {
      document.getElementById(`${id}trans3`).beginElement();
      setTimeout(() => this.goToTicketHistory(), 500);
    }
  };

  transitionImageOver = (id) => {
    const isIE = /*@cc_on!@*/ false || !!document.documentMode;
    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;
    const windows = isIE || isEdge;
    if (windows) {
      document
        .getElementById("issue-request-component-wrapper")
        .classList.add("windows");
    } else {
      document.getElementById(`${id}trans1`).beginElement();
    }
  };

  updateRefreshCount = () => {
    const { updateCount } = this.state;
    this.setState({ updateCount: updateCount + 1 });
  };

  render() {
    const {
      breakpoint,
      location,
      site,
      navigate,
      company_info,
      company_info: { customer: { id: orgId } } = {},
      auth_status,
      setModalContent,
      permissions: pages,
      tour: { runHomeTour: { runHomeTour } } = {},
    } = this.props;

    const {
      showTitleTicketCount,
      hasShippingTickets,
      tickets,
      tourSelected,
      stepIndex,
      ticketType,
      updateCount,
    } = this.state;
    const steps = [
      {
        title: "Support Overview",
        content:
          "Let's carry on to the Support module. It is where most interactions occur.",
        placement: "center",
        locale: { skip: "S-K-I-P" },
        target: ".header-section",
        module: "support",
      },

      {
        target: "#remote-hands-component",
        content:
          "Ever need us to do something for you like power cycling a server or adding gear to a rack? A Remote Hands request is the place to get us started.",
        module: "support",
      },
      {
        target: "#guest-access-component",
        content:
          "Do you ever need a vendor to come to the data center and do some work on your equipment? Just submit a Guest Access request, but please allow us 24 hours before they arrive.",
        module: "support",
      },
      {
        target: "#issue-request-component-wrapper",
        content:
          "Ah! The Issue request will satisfy most of your needs. You can submit support requests for just about anything here. I have a tour for this as well, and I can stage it up for you when we are done.",
        module: "support",
      },
      {
        target: ".recent-tickets-wrapper",
        content: "Here you will be able to view your recent tickets.",
        module: "support",
        customNextButton: (
          <BloxButton
            className="buttons41"
            id="continue-tour"
            text="Next"
            module="support"
            enabled={true}
            onClick={() => {
              document.getElementById("recent-ticket-0").click();
            }}
            cypressId="continue-tour"
          />
        ),
      },
    ];

    const hasViewTicketsAccess = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "view-ticket-status"
    );
    const hasIssueRequestAccess = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "add-support"
    );
    const hasGuestAccess = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "add-guest-access"
    );
    const hasRemoteHandsAccess = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "add-remote-hands"
    );
    return (
      <BloxPage
        name="page colocation-overview-page"
        layout={LAYOUT_CONFIG[breakpoint]}
        breakpoint={breakpoint}
        location={location}
      >
        <div key={`recentTickets`} className="recentTickets">
          <ComponentWrapper
            site={site}
            breakpoint={breakpoint}
            title={"Recent Tickets"}
            hideBorder
          >
            <RecentTickets
              orgId={orgId}
              onSelectTicket={this.onSelectTicket}
              ticketType={ticketType}
              update={updateCount}
            />
          </ComponentWrapper>
        </div>
        <div key={`ticketDonut`} className="ticketDonut">
          {hasViewTicketsAccess && (
            <ComponentWrapper
              site={site}
              breakpoint={breakpoint}
              title={showTitleTicketCount ? "Support Tickets" : ""}
              hideBorder
              titleClass="center"
            >
              <DonutChart
                ticketType={TICKET_TYPES.SUPPORT}
                showTitle={this.showTitleTicketCount}
                goToTicketHistory={this.goToTicketHistory}
                id="support"
                breakpoint={breakpoint}
                pages={pages}
                ticketTypePermission={ticketType}
              />
            </ComponentWrapper>
          )}
        </div>
        <div key={`shippingRequest`} className="shippingRequest">
          {hasViewTicketsAccess && hasShippingTickets && (
            <ComponentWrapper
              site={site}
              breakpoint={breakpoint}
              title={showTitleTicketCount ? "Shipping" : ""}
              hideBorder
            >
              <ActionButton
                cypressId="issue-request-component"
                module="support"
                className="aqua"
                id="special-id-1"
                onMouseOver={() => this.transitionImageOver("special-id-1")}
                onClick={() => this.onClick("special-id-1")}
              >
                <ShippingSVG id="special-id-1" />
              </ActionButton>
            </ComponentWrapper>
          )}
        </div>
        <div key={`tourButton`} className="tourButton">
          {pages && (
            <>
              <Joyride
                steps={steps}
                continuous={true}
                showProgress
                showSkipButton
                styles={{
                  options: {
                    zIndex: 5000,
                  },
                }}
                tooltipComponent={JoyRideToolTip}
                run={runHomeTour}
                disableScrolling={true}
                callback={this.closeTour}
                disableOverlayClose={true}
              />
              {pages && (
                <IssueRequestTour
                  tourSelected={tourSelected}
                  stepIndex={stepIndex}
                  handleTourCallback={this.handleTourCallback}
                  setStepIndex={this.setStepIndex}
                />
              )}
            </>
          )}
        </div>
        <div key={`issueRequest`} className="issueRequest">
          {hasIssueRequestAccess && (
            <ComponentWrapper title="Submit New Ticket" hideBorder>
              <IssueRequest
                breakpoint={breakpoint}
                navigate={navigate}
                pages={pages}
                location={location}
                ticketType={ticketType}
                updateTickets={this.updateRefreshCount}
              />
            </ComponentWrapper>
          )}
        </div>

        <div key={`remoteHandsRequest`} className="remoteHandsRequest">
          {hasRemoteHandsAccess && (
            <ComponentWrapper title="Services Request" hideBorder>
              <ServiceRequestProvider>
                <ServiceRequest
                  navigate={navigate}
                  type="REMOTE_HANDS"
                  breakpoint={breakpoint}
                  goTo={this.goTo}
                  tickets={tickets}
                  pages={pages}
                  company_info={company_info}
                  auth_status={auth_status}
                  setModalContent={setModalContent}
                  location={location}
                  ticketType={ticketType}
                  updateTickets={this.updateRefreshCount}
                />
              </ServiceRequestProvider>
            </ComponentWrapper>
          )}
        </div>
        <div key={`guestAccessRequest`} className="guestAccessRequest">
          {hasGuestAccess && (
            <ComponentWrapper hideTitle hideBorder>
              <ServiceRequestProvider>
                <ServiceRequest
                  type="GUEST_ACCESS"
                  navigate={navigate}
                  breakpoint={breakpoint}
                  tickets={tickets}
                  pages={pages}
                  company_info={company_info}
                  auth_status={auth_status}
                  setModalContent={setModalContent}
                  location={location}
                  ticketType={ticketType}
                  updateTickets={this.updateRefreshCount}
                />
              </ServiceRequestProvider>
            </ComponentWrapper>
          )}
        </div>
      </BloxPage>
    );
  }
}
function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
    site: state.site_tracking,
    permissions: state.permissions,
    tour: state.tours,
  };
}

export default connect(mapStateToProps, {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
  updatePermissions,
  setHomeTour,
})(OverviewPage);
